import PropTypes from 'prop-types';

const displayName = 'ConfirmPanel';
const propTypes = {
  biller: PropTypes.object,
  checkout: PropTypes.object,
  checkoutParam: PropTypes.object,
  visible: PropTypes.bool,
  billerWithTnc: PropTypes.bool,
  checkedTnc: PropTypes.bool,
  selectedPaymentMethod: PropTypes.object,
  onChangePanel: PropTypes.func,
  onCloseConfirmPanel: PropTypes.func,
  onConfirm: PropTypes.func,
};
const defaultProps = {
  billerWithTnc: false,
  checkedTnc: false,
};

export default { displayName, propTypes, defaultProps };
